export const readRetentionReference = (rawReferences, referenceId) => {
  if (!referenceId) return null
  try {
    return JSON.parse(rawReferences || '{}')?.references?.[referenceId] || null
  } catch {
    return null
  }
}

export const getReferenceFileName = file => {
  const path = typeof file === 'string' ? file : file?.key
  if (typeof path !== 'string') return null
  // Only http(s) URLs carry a query or fragment; '?' and '#' are legal inside S3 keys.
  const withoutQuery = /^https?:\/\//i.test(path) ? path.split(/[?#]/)[0] : path
  const name = withoutQuery.split('/').pop()
  try {
    return decodeURIComponent(name)
  } catch {
    return name
  }
}
